export function formatNumber(n: number | undefined | null) {
  if (n == null) return "0";
  return new Intl.NumberFormat().format(n);
}

export function formatCurrency(n: number | undefined | null, opts: { compact?: boolean } = {}) {
  if (n == null) return "$0";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    notation: opts.compact ? "compact" : "standard"
  }).format(n);
}

export function formatPercent(n: number | undefined | null) {
  if (n == null) return "0.0%";
  return (n * 100).toFixed(1) + "%";
}

export function formatPercentRaw(n: number | undefined | null) {
  return formatPercent(n);
}

export function safeRatio(num: number, den: number) {
  if (!den) return null;
  return num / den;
}

export function statusTone(status: string) {
  const s = status.toLowerCase();
  if (s.includes("good") || s.includes("healthy")) return "good";
  if (s.includes("risk") || s.includes("warn")) return "warn";
  if (s.includes("bad") || s.includes("poor")) return "bad";
  return "muted";
}

export function formatDate(d: string | undefined | null) {
  if (!d) return "—";
  return new Date(d).toLocaleDateString();
}

export function formatDateTime(d: string | undefined | null) {
  if (!d) return "—";
  return new Date(d).toLocaleString();
}
